export { FaqService } from '../services/faq.service';

